/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* eslint-disable import/no-unresolved, import/default */

import siloFieldsetTemplate from './silo-fieldset.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('agrolog.admin.silo', [])
    .directive('agSilo', Silo)
    .name;

/*@ngInject*/
function Silo() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            silo: '=',
            theForm: '='
        },
        controller: SiloController,
        controllerAs: 'vm',
        templateUrl: siloFieldsetTemplate
    };
}

/* eslint-disable angular/angularelement */


/*@ngInject*/
function SiloController($scope, agTypes) {

    let vm = this;

    vm.siloTypes = agTypes.siloType;
    vm.siloData = null;

    $scope.$watch('vm.silo', () => {
        vm.siloData = null;
        if (vm.silo) {
            if (angular.isUndefined(vm.silo.viewrotation) || vm.silo.viewrotation == null) {
                vm.silo.viewrotation = 0;
            }
            if (!vm.siloTypes[vm.silo.siloType]) {
                vm.silo.siloType = vm.siloTypes.cylinder;
            }
            vm.siloData = {
                silo: vm.silo,
                sensorLines: []
            }
        }
    });
}
